/*
 * @Author: yyl
 * @Date: 2025-06-25 15:38:59
 * @LastEditTime: 2025-06-27 15:14:53
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/mixins/resize.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
export default {

  data() {
    return {
      isMobile: false,
    }
  },

  mounted() {
    if (typeof this.onResize === 'function') {

      this.onResize()

      window.addEventListener('resize', this.onResize)
    }
  },



  beforeDestroy() {
    if (typeof this.onResize === 'function') {
      window.removeEventListener('resize', this.onResize)
    }
  },
}
